import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-lib-loader-dot-pulse',
    templateUrl: './loader-dot-pulse.component.html',
    styleUrls: ['./loader-dot-pulse.component.scss'],
    standalone: false,
})
export class LoaderDotPulseComponent {
    @Input() size: 'small' | 'default' = 'default';
    @Input() color: 'primary' | 'gray' = 'primary';

    constructor() {}
}
